const paths = {
  main: '/shipping-costs',
};

export default paths;
